import type { ComponentProps, ReactNode, ElementType } from 'react'
import { classNames } from '~/utils/client/helpers'

type PolymorphicAsProp<E extends ElementType> = {
  as?: E
}

type PolymorphicProps<E extends ElementType> = {
  className?: string
  children?: ReactNode
  spacing?: 'regular' | 'large' | 'xl' | 'small' | 'tiny'
  as?: E
} & Omit<ComponentProps<E>, 'as'> &
  PolymorphicAsProp<E>

export const Grid = <As extends ElementType = 'div'>({
  spacing = 'regular',
  className,
  children,
  as,
  ...props
}: PolymorphicProps<As>) => {
  const Element = as || 'div'
  const dynamicClassName = classNames(
    spacing === 'large'
      ? 'layout-grid--spacing-large'
      : spacing === 'xl'
      ? 'layout-grid--spacing-xl'
      : spacing === 'small'
      ? 'layout-grid--spacing-small'
      : spacing === 'tiny'
      ? 'layout-grid--spacing-tiny'
      : ''
  )
  return (
    <Element className={classNames('layout-grid', dynamicClassName, className)} {...props}>
      {children}
    </Element>
  )
}
